import axios from 'axios';
import '../Sys/config.js';

var apiUrl = global.platformURI;

let programmeOptionsCache = null;
let programmeOptionsRequest = null;
let learningPlansCache = null;

export class ProjectServices {
  constructor() {
    axios.interceptors.request.use(
      function (config) {
        let token = localStorage.getItem('ssoToken');
        config.headers.Authorization = `Token ${token}`;
        config.baseURL = apiUrl;
        return config;
      },
      error => {
        console.log('error.response.status', error);
        return error;
      }
    );
  }

  // get customer list
  getCustomerList() {
    return axios.get(`main/customerdropdown`).then(res => res.data);
  }

  getProgrammeOptions({ force = false } = {}) {
    if (!force && programmeOptionsCache) {
      return Promise.resolve(programmeOptionsCache);
    }
    if (!force && programmeOptionsRequest) {
      return programmeOptionsRequest;
    }
    programmeOptionsRequest = axios
      .get('project/programmeoptions')
      .then(res => {
        programmeOptionsCache = res.data;
        return res.data;
      })
      .finally(() => {
        programmeOptionsRequest = null;
      });
    return programmeOptionsRequest;
  }

  getAllLicenseListProject(url) {
    return axios.get(url).then(res => res.data);
  }
  deleteLicences(id, data) {
    return axios
      .put(`project/licensedetail/${id}`, data)
      .then(res => res.data);
  }
  // get assessment list
  getAssessmentsList(id) {
    if (id) {
      return axios
        .get(`main/assessmentdropdown?customer_id=` + id)
        .then(res => res.data);
    } else {
      return axios
        .get(`main/assessmentdropdown`)
        .then(res => res.data);
    }
  }
  // get apprenticeship list
  getApprenticeshipsList(id) {
    if (id) {
      return axios
        .get(`main/apprenticeshipdropdown?customer_id=` + id)
        .then(res => res.data);
    }
    return axios
      .get(`main/apprenticeshipdropdown`)
      .then(res => res.data);
  }
  // get course list
  getCoursesList(id) {
    if (id) {
      return axios
      .get(`main/coursedropdown?customer_id=` + id)
      .then(res => res.data);
    } else {
      return axios.get(`main/coursedropdown`).then(res => res.data);
    }
  }
  getLabsList(id, query) {
    if (id) {
      return axios
      .get(`main/labsdropdown?customer_id=` + id)
      .then(res => res.data);
    } else {
      return axios.get(`main/lab/${query}`).then(res => res.data);
    }
  }
  // get customer admin list
  getCustomerAdminList(payload) {
    return axios
      .post(`main/customeradmindropdown`, payload)
      .then(res => res.data);
  }
  //   get getUserListForAllocate
  getUserListForAllocate(payload) {
    return axios
      .post(`project/customerusers`, payload)
      .then(res => res.data);
  }
  //   get getlicenseinformation
  getLicenseinformation(payload) {
    return axios
      .post(`project/licenseinformation`, payload)
      .then(res => res.data);
  }
  // Submit allocate user
  addAllocateUser(payload, id) {
    return axios
      .post(`project/userallocation/${id}`, payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : err);
  }
  removeAllocateUser(payload, id) {
    return axios
      .put(`project/userallocation/${id}`, payload)
      .then(res => res.data);
  }
  getDetailLicenseCustomer(id) {
    return axios
      .get(`project/licensedetail/${id}`)
      .then(res => res.data);
  }

  addProject(payload, id) {
    if (id) {
      return axios.put(`project/projectdetail/${id}`, payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : err);
    } else {
      return axios
        .post('project/createproject', payload)
        .then(res => res.data)
        .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }
  }
  getAllProject(url) {
    return axios.get(url).then(res => res.data);
  }
  getProjectDetail(id) {
    return axios
      .get(`project/projectdetail/${id}`)
      .then(res => res.data);
  }
  getLearningAccess(projectId) {
    return axios
      .get(`project/learningaccess/${projectId}`)
      .then((res) => ({ ...(res.data || {}), httpStatus: res.status }))
      .catch((err) => {
        const data = err.response && err.response.data;
        const body = data && typeof data === 'object' && !Array.isArray(data)
          ? data
          : { message: 'Unable to load Learning Hub seats' };
        return { ...body, httpStatus: err.response ? err.response.status : 0 };
      });
  }

  saveLearningAccess(projectId, payload) {
    return axios
      .put(`project/learningaccess/${projectId}`, payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : null);
  }

  addLearningAllocation(projectId, payload) {
    return axios
      .post(`project/learningaccess/${projectId}/allocations`, payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : null);
  }

  updateLearningAllocation(projectId, allocationId, payload) {
    return axios
      .patch(`project/learningaccess/${projectId}/allocations/${allocationId}`, payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : null);
  }

  /** Plans offered before a project exists. Resolves to [] when the endpoint is not deployed. */
  getLearningAccessPlans() {
    if (learningPlansCache) return Promise.resolve(learningPlansCache);
    return axios
      .get('project/learningaccess/plans')
      .then((res) => {
        const body = res.data || {};
        const plans = body.data?.available_plans || body.available_plans || (Array.isArray(body.data) ? body.data : []);
        learningPlansCache = Array.isArray(plans) ? plans : [];
        return learningPlansCache;
      })
      .catch(() => []);
  }
  getProjectDetails(id, provider) {
    const providerQuery = provider ? `&provider=${encodeURIComponent(provider)}` : '';
    return axios
      .get(`main/assign_customer_license?customer_id=${id}${providerQuery}`)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : err);
  }
  assignLicense(url, payload) {
    if (url !== '') {
      return axios.put(url, payload).then(res => res.data);
    } else {
      return axios
        .post('main/assign_customer_license', payload)
        .then(res => res.data);
    }
  }

  userByProject(id, { page, pageSize, search } = {}) {
    const params = new URLSearchParams({ project_id: id });
    if (page) params.set('page', String(page));
    if (pageSize) params.set('page_size', String(pageSize));
    if (search !== undefined) params.set('search', search);
    return axios
      .get(`main/userbyproject?${params.toString()}`)
      .then(res => res.data);
  }

  allProjectsByCustomer(id) {
    return axios
      .get(`project/all_projects_by_customer?customer_id=${id}`)
      .then(res => res.data);
  }

  getProjectSummary(id) {
    return axios
      .get(`main/project_summary?project_id=${id}`)
      .then(res => res.data);
  }
  getLabsByCourse(payload) {
    return axios
      .post('main/labs_mapped_with_course', payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : err);
  }

  assignProjectToUsers(payload) {
    return axios
      .post('main/assign_project_to_users', payload)
      .then(res => res.data)
      .catch(err => (err.response && err.response.data) ? err.response.data : err);
  }

  getAssignmentMatrix(projectId, { search, page, pageSize, filters } = {}) {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (page) params.set('page', String(page));
    if (pageSize) params.set('page_size', String(pageSize));
    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value) params.set(key, value);
    });
    const query = params.toString();
    return axios
      .get(`project/assignment_matrix/${projectId}${query ? `?${query}` : ''}`)
      .then(res => res.data);
  }

  /** Attribute values for filtering project users. Resolves to null when the endpoint is not deployed. */
  getUserFacets(projectId) {
    return axios
      .get(`project/${projectId}/user_facets`)
      .then(res => res.data)
      .catch(() => null);
  }

  saveAssignmentsBatch(projectId, payload) {
    return axios
      .post(`project/assignments/${projectId}/batch`, payload)
      .then(res => res.data);
  }

  downloadAssignmentTemplate(projectId, fileFormat = 'xlsx') {
    const query = fileFormat === 'csv' ? '?file_format=csv' : '';
    return axios
      .get(`project/assignments/${projectId}/template${query}`, { responseType: 'blob' })
      .then(res => ({
        blob: res.data,
        filename: (/filename="?([^";]+)"?/i.exec(res.headers?.['content-disposition'] || '') || [])[1],
      }));
  }

  previewAssignmentUpload(projectId, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', 'preview');
    return axios
      .post(`project/assignments/${projectId}/bulk_upload`, formData)
      .then(res => res.data);
  }

  applyAssignmentUpload(projectId, uploadId) {
    return axios
      .post(`project/assignments/${projectId}/bulk_upload`, { mode: 'apply', upload_id: uploadId })
      .then(res => res.data);
  }
}
